module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "buttons"
  }, [_c('b-button', {
    attrs: {
      "size": "is-small",
      "icon-left": "github-circle"
    }
  }, [_vm._v("\n                Add\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "icon-left": "github-circle"
    }
  }, [_vm._v("\n                Add\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "is-medium",
      "icon-left": "github-circle"
    }
  }, [_vm._v("\n                Add\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "is-large",
      "icon-left": "github-circle"
    }
  }, [_vm._v("\n                Add\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('b-button', {
    attrs: {
      "type": "is-danger",
      "icon-left": "delete"
    }
  }, [_vm._v("\n                Delete\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-danger",
      "icon-right": "delete"
    }
  }, [_vm._v("\n                Delete\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-danger",
      "icon-right": "delete"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5abdcbc8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/button/examples/ExIcons.vue
// module id = 974
// module chunks = 21 242